import React from 'react';
import '../styles/Ceiling.css';
import { Top } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function Ceiling(props) {
    return (
        <div className="ceiling-element-container bg-colour-red-01">
            <div className="ceiling-element-title-container">
                <Top
                    className="ceiling-element-title-icon"
                    fill={colour.red03}
                />
                <span className="body-bold colour-error">
                    Price ceiling
                </span>
            </div>
            <span className="body-regular colour-primary">
                This property is substantially nicer than the subject, so we think it's a price ceiling.
            </span>
        </div>
    )
};

export default Ceiling;